import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getShoppingTrend } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Body from './Body';
import Header from './Header';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportShoppingTrend } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class ShoppingTrend extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            showBody: false,
            model: {
                year: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date.getFullYear(), `ShoppingTrendYear`);
    }

    getReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        this.props.getShoppingTrend({ year, branch });
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        return (
            <Grid headerContent={reportShoppingTrend}>
                <div className="bg-light-opacity pb-2">
                    <div className="row m-0 pa-2">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="d-flex a-items">
                                <h2>{LOOKUP.report.shoppingTrend.text}</h2>
                                <KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-shopping-trend-report-1" />
                            </div>
                            <h5>{LOOKUP.report.shoppingTrend.description}</h5>

                        </div>
                    </div>
                    <div className="pa-2">
                        <Header
                            loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} showBody={this.showBody} />
                    </div>
                </div>
                <div>
                    {
                        this.state.showBody && this.props.shoppingTrend &&
                        <CardSimple>
                            <Body
                                shoppingTrend={this.props.shoppingTrend}
                                searchedYear={this.props.year}
                                searchedBranch={this.props.branchText}
                                loggedBranch={this.props.loggedBranch}
                                userBranch={this.props.userBranchText}
                            />
                            <DateCurrentDisplay />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        shoppingTrend: state.reports.shoppingTrend,
        loggedBranch: state.common.branchId,
        year: state.form.ShoppingTrendYear,
        branch: state.form.ShoppingTrendBranchOption,
        branchText: state.form.ShoppingTrendBranchOptionText,
        userBranchText: state.common.userBranches
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getShoppingTrend: model => dispatch(getShoppingTrend(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ShoppingTrend));